import { useState } from "react";
import styles from "./adminmodal.module.css";
import Select from "react-select";

export default function AdminModal({alternativeLevel, ispopular, handleUpdate, handleClose}: {alternativeLevel: number, ispopular: boolean, handleUpdate(level: number, popular: boolean): void, handleClose(): void}) {
    const [isPopular, setIsPopular] = useState(ispopular);
    const levelOptions = [{value: 1, label: "Bronze"}, {value: 2, label: "Silver"},{value: 3, label: "Gold"}];
    const preSelected = levelOptions.find(x => x.value === alternativeLevel) || levelOptions[0];

    const handleSave = () => {
        const selectedalternativeLevel = document.querySelector('input[name="alternativeLevel"]') as HTMLInputElement
        const isPopularSelected = document.querySelector('#isPopular') as HTMLInputElement
        handleUpdate(Number(selectedalternativeLevel.value), isPopularSelected.checked);
    }
    
    return (
        <div className={styles.backdrop}>
            <div className={styles.modal}>
                <h3>Update</h3>
                <div className={styles.alternative_level}>
                    <label htmlFor="alternativeLevel">Alternative level</label>
                    <Select
                        className="basic-single"
                        classNamePrefix="select"
                        defaultValue={preSelected}
                        isDisabled={false}
                        isLoading={false}
                        isClearable={false}
                        isRtl={false}
                        isSearchable={false}
                        name="alternativeLevel"
                        id="alternativeLevel"
                        options={levelOptions}
                    />
                </div>
                <div className={styles.popular}>
                    <label htmlFor="isPopular">Is popular</label>
                    <input type="checkbox" id="isPopular" checked={isPopular} onChange={() => setIsPopular(!isPopular)}/>
                </div>
                <div className={styles.buttons}>
                    <button className="button" onClick={() => handleSave()}>Save</button>
                    <button className="button button_black" onClick={() => handleClose()}>Close</button>
                </div>
            </div>
        </div>
    )
}